//TO-DO

import { ShortcodeFn } from 'components/vendor/Contentful/richText/ShortcodeManager'
import { BasicCrossSell } from 'components/content/CrossSell/Basic'
import { FionaProducts } from 'parameters/general'
import React from 'react'

export const crossSellShortcode: ShortcodeFn = (name, attrs) => {
	return <BasicCrossSell product={attrs['basic-xsell'] as FionaProducts} isInsideArticle />
}
